<template lang="pug">
  section
    b-container(v-if="order")
      h1.mt-0 {{ `Order #${order.id}` }}
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'Orders'}")
          font-awesome-icon.mr-2(icon="chevron-left")
          span Back to Orders
      .row
        .col-12
          b-card.mt-3
            .container
              .row
                .col-6
                  h4 Summary
                  p Details
                  ul.list-unstyled
                    li
                      span.font-weight-bold Order
                      span.ml-1 {{ `#${order.id}` }}
                    li
                      span.font-weight-bold Type
                      span.ml-2 {{ order.type  }}
                    li.pb-3
                      span.font-weight-bold Status
                      b-badge.ml-2(variant="dark") {{ order.status || 'unpaid' }}
                    li
                      span.font-weight-bold Sub
                      span.ml-1 {{ formatRandsCents(order.sub_total) }}
                    li
                      span.font-weight-bold Shipping
                      span.ml-1 {{ formatRandsCents(order.shipping_cost) }}
                    li
                      span.font-weight-bold Service fees
                      span.ml-1 {{ formatRandsCents(order.service_fee) }}
                    li
                      span.font-weight-bold VAT
                      span.ml-1 {{ formatRandsCents(order.vat_amount) }}
                    li
                      span.font-weight-bold TOTAL
                      span.ml-1 {{ formatRandsCents(order.total) }}
                    li
                      span.font-weight-bold Payment
                      span.ml-1 {{ order.payment_status || 'unpaid' }}
                .col-md-6
                  h4 Actions
                  content-loader(:height="5", v-if="alert.busy")
                  div(v-else="")
                    p Please select
                    ul
                      li(v-if="order.status == 'paid'")
                        a(@click="confirmOrder") Confirm Order
                      li(v-else="")
                        a(@click="completeOrder()") Complete Order
                      li
                        a(@click="cancelOrder") Cancel Order
                      li(v-if="order.lines[0].shipment_id")
                        router-link.d-block(:to="{ name: 'Shipments', query: { order: order.id} }") Manage Shipments
        //.col-md-4(v-if="!['completed', 'cancelled'].includes(order.payment_status)")
          b-card.mt-3
            b-form(@submit.prevent="submitForm")
              b-container
                h5 RECORD PAYMENT
                .row
                  .col-12
                    b-form-group
                      label PAYMENT DATE
                      b-form-datepicker(v-model="inputForm.payment_date", value-as-date)
                  .col-6
                    p {{ formatRandsCents(order.total) }}
                  .col-6
                    p {{ `Ref: ${order.payment_ref}` }}
                button-load(type="submit", :flag="alert.busy", label="SUBMIT", classes="btn-outline")
                b-button.btn-outline.ml-3(@click="cancelOrder") CANCEL ORDER
        .col-md-6(v-if="order.lines[0].address_origin")
          b-card.mt-3
            h4 Customer
            b-container
              span
                p.m-0 {{ order.customer_name }}
                p.m-0 {{ order.customer_email }}
                p.m-0 {{ order.customer_phone }}
                br
                p.m-0 {{ order.lines[0].address_origin.line_1 }}
                p.m-0 {{ order.lines[0].address_origin.line_2 }}
                p.m-0 {{ order.lines[0].address_origin.suburb }}
                p.m-0 {{ order.lines[0].address_origin.city }}
                p.m-0 {{ order.lines[0].address_origin.zip }}
        .col-md-6
          b-card.table-card.mt-3
            .container
              h4 Items
              b-table(:items="order.lines", :fields="fields", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
                  template(v-slot:cell(compTitle)="row")
                    h4.p-0.m-0
                      router-link.d-block(:to="{ name: 'Piece', params: { pieceId: row.item.art_id } }") {{ `${row.item.art_title}` }}
                    router-link.d-block(:to="{ name: 'Artist', params: { artistId: row.item.artist_id } }") {{ `by ${row.item.artist_name}` }}
                    b-badge.ml-2(v-if="row.item.is_rental", variant="dark") rental
                  //- template(v-slot:cell(compCommission)="row") {{ formatRands(row.item.commission) }}
                  //- template(v-slot:cell(compToArtist)="row") {{ formatRands(row.item.line_total - row.item.commission) }}
                  template(v-slot:cell(compLineTotal)="row") {{ formatRands(row.item.line_total) }}
                  template(v-slot:cell(compStatus)="row")
                    b-badge(:variant="row.item.shipment_status==='completed'?'dark':'light'") {{ row.item.status }}
                  template(v-slot:cell(actions)='row')
                    .text-right
                      a(@click='row.toggleDetails')
                        font-awesome-icon(icon="caret-down")
                          //b-dropdown-item
                            b-link(:to="{ name: 'Return', params: { customerOrderLineId: row.item.id }}") Return Item
    b-container(v-else="")
      content-loader(:height="7")


</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
// import router from '@/router';

export default {
  name: 'Order',
  mixins: [standardMix],
  data() {
    return {
      order: null,
      fields: [
        { key: 'compTitle', label: 'Item', sortable: true },
        // { key: 'compCommission', label: 'Commission' },
        // { key: 'compToArtist', label: 'To Artist' },
        // { key: 'compLineTotal', label: 'Line' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
  },
  methods: {
    async confirmOrder() {
      try {
        this.clear();
        this.busy();
        // eslint-disable-next-line no-restricted-syntax
        for (const line of this.order.lines) {
          // eslint-disable-next-line no-await-in-loop
          await apiService.confirmOrderLine(line.id);
        }
        this.order = await apiService.getOrder(this.$route.params.orderId);
        this.success('Order confirmed');
      } catch (error) {
        this.error(error);
      }
    },
    async cancelOrder() {
      try {
        this.clear();
        this.busy();
        const order = await apiService.cancelOrder(this.order.id);
        this.order.status = order.status;
        this.success('Order cancelled');
      } catch (error) {
        this.error(error);
      }
    },
    async completeOrder() {
      try {
        this.clear();
        this.busy();
        const order = await apiService.completeOrder(this.$route.params.orderId);
        this.order.status = order.status;
        this.success('Order complete');
      } catch (error) {
        this.error(error);
      }
    },
  },
  async created() {
    if (this.$route.params.orderId) {
      try {
        this.loading();
        this.order = await apiService.getOrder(this.$route.params.orderId);
        this.clear();
      } catch (error) {
        this.error('Order not found');
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Order.vue